import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '400px',
  },
}));

const CaixaField = (props) => {
  const classes = useStyles();

  const record = useRecordContext(props);
  const value = record ? record.record.venda.sessao.caixa.nome : '';

  return <Typography className={classes.text}>{value}</Typography>;
};

export default CaixaField;
